export const CLEAR = "networking/CLEAR";
export const ADD_LOG_ENTRY = "networking/ADD_LOG_ENTRY";
